export default function ResearchHeader() {
  return (
    <div className="bg-[#0d1f35] text-white py-20 px-8 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at 70% 50%, #c89211 0%, transparent 50%)'
      }} />
      <div className="max-w-3xl relative z-10">
        <span className="inline-flex items-center gap-2 bg-dorado-uady/20 border border-dorado-uady/40 text-dorado-uady text-micro font-semibold px-3 py-1 rounded-full mb-4">
          🏆 EXCELENCIA ACADÉMICA
        </span>
        <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
          Fronteras de la Robótica e Industria 4.0
        </h1>
        <p className="text-white/60 text-mini leading-relaxed max-w-xl">
          Desarrollamos soluciones tecnológicas avanzadas para los desafíos industriales del mañana, integrando sistemas ciberfísicos, inteligencia artificial y manufactura inteligente.
        </p>
      </div>
    </div>
  );
}
